'use strict';

var _require = require('../../utils'),
    withTimeoutOption = _require.withTimeoutOption;

module.exports = function (_ref) {
  var keychain = _ref.keychain;
  return withTimeoutOption(function (name, options) {
    options = options || {};
    return keychain.createKey(name, options.type || 'rsa', options.size || 2048);
  });
};